/**
 * @generated SignedSource<<1e72b221db30c6dd58d4a18a3c908cd9>>
 * @relayHash 667db9b1207176451cb2198029bc1794
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 263c5187fe4d45dd66f4564bd6f052b5aa2b86c867264433913ce3020f843c0c

import type { ConcreteRequest } from 'relay-runtime';
export type ViewSpaceExternalCollaboratorsDialogQuery$variables = {
  spaceKey?: string | null;
};
export type ViewSpaceExternalCollaboratorsDialogQuery$data = {
  readonly space: {
    readonly currentUser: {
      readonly isAdmin: boolean;
    };
    readonly externalCollaboratorCount: number;
    readonly id: string | null;
    readonly name: string | null;
  } | null;
};
export type ViewSpaceExternalCollaboratorsDialogQuery = {
  response: ViewSpaceExternalCollaboratorsDialogQuery$data;
  variables: ViewSpaceExternalCollaboratorsDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "externalCollaboratorCount"
      },
      {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isAdmin"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ViewSpaceExternalCollaboratorsDialogQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewSpaceExternalCollaboratorsDialogQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "667db9b1207176451cb2198029bc1794",
    "id": "263c5187fe4d45dd66f4564bd6f052b5aa2b86c867264433913ce3020f843c0c",
    "metadata": {},
    "name": "ViewSpaceExternalCollaboratorsDialogQuery",
    "operationKind": "query",
    "text": "query ViewSpaceExternalCollaboratorsDialogQuery($spaceKey:String){space(key:$spaceKey){id,name,externalCollaboratorCount,currentUser{isAdmin}}}"
  }
};
})();

(node as any).hash = "722ca76340bcbe86e394e6f8663add12";

export default node;
